import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV } from '../../hooks';
import { ForfeitureReportTableParams } from '../ForfeitureReport.types';

export const QUERY_KEY = 'EXPORT_FORFEITURE_REPORT_CSV';
const useForfeitureReportExportCSVQuery = (params: ForfeitureReportTableParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);

  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(API_URL.REPORTS_FORFEITURE_REPORT_BREAKDOWN_EXPORT_CSV, {
        params: _.pickBy({
          employer_id: params.employerId,
          show_ssn: params.isSSNShowed,
          isSSNShowed: params.isSSNShowed,
          search_value: params.searchString,
          forfeiture_report_group: params.forfeitureGroup,
          plan_year_period:
            params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
              ? params?.planYearPeriod.join(',')
              : undefined,
        }),
      }),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response?.data?.data, 'csv', 'end_of_year');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default useForfeitureReportExportCSVQuery;
